import { isNullOrEmpty } from "common-utils";
import * as React from "react";
import { useSearchParams } from "react-router-dom";

interface IUseUrlSearch {
    onSearchParamsChange?: (params: URLSearchParams) => void;
}

export const useUrlSearch = (_props?: IUseUrlSearch) => {
    const { onSearchParamsChange } = _props || {};
    const [searchParams, setSearchParams] = useSearchParams();

    const getSearchParam = (key: string) => {
        return searchParams.get(key);
    };

    const updateSearchParams = (params: {[key:string]:any}) => {
        const newParams = new URLSearchParams(searchParams.toString());
        Object.entries(params).forEach(([key, value]) => {
            if (isNullOrEmpty(value)) {
                newParams.delete(key);
                return;
            }
            newParams.set(key, value);
        });
        setSearchParams(newParams);
    };

    const removeSearchParams = (keys: string[]) => {
        const newParams = new URLSearchParams(searchParams.toString());
        keys.forEach(key => newParams.delete(key));
        setSearchParams(newParams);
    };

    React.useEffect(() => {
        if (onSearchParamsChange) {
            onSearchParamsChange(searchParams);
        }
    }, [searchParams, onSearchParamsChange]);

    return {
        searchParams,
        setSearchParams,
        getSearchParam,
        updateSearchParams,
        removeSearchParams,
    };
};
